import { render, staticRenderFns } from "./AdminEvents.vue?vue&type=template&id=11aefbaf&scoped=true"
import script from "./AdminEvents.vue?vue&type=script&lang=js"
export * from "./AdminEvents.vue?vue&type=script&lang=js"
import style0 from "./AdminEvents.vue?vue&type=style&index=0&id=11aefbaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aefbaf",
  null
  
)

export default component.exports